import { WalletLinesModel } from "./wallet-lines.model";

export const IWallet = Object.freeze({
  indentifierId: "identifier_id",
  indentifierType: "identifier_type",
  amount: "wallet_amount",
  total: "total",
  walletLines: "data",
});

export class WalletModel {
  constructor(data = {}) {
    this[IWallet.indentifierId] = data[IWallet.indentifierId];
    this[IWallet.indentifierType] = data[IWallet.indentifierType];
    this[IWallet.amount] = data[IWallet.amount];
    this[IWallet.total] = data[IWallet.total];
    this[IWallet.walletLines] = data[IWallet.walletLines];
  }

  getIdentifierId() {
    return this[IWallet.indentifierId];
  }

  getType() {
    return this[IWallet.indentifierType];
  }

  getAmount() {
    return this[IWallet.amount];
  }

  getWalletLines() {
    return this[IWallet.walletLines].map((walletLine) => new WalletLinesModel(walletLine));
  }

  getTotalLines() {
    return this[IWallet.total];
  }
}
